// extracted by mini-css-extract-plugin
export var centerAlign = "Lead-module--center-align--ec25d";
export var lead = "Lead-module--lead--cead2";
export var leftAlign = "Lead-module--left-align--344b7";
export var rightAlign = "Lead-module--right-align--3005a";